import React, { useCallback } from "react";
import ReactDOM from "react-dom";
import useKey from "utils/KeyListener";

/**
 * RightSidebar
 * - Portal'd into #modal-root (same as Modal)
 * - Click outside / Escape closes
 * - Slide-in animation handled via CSS classes in index.scss
 */
export default function RightSidebar({ children, closeCb, width }) {
  const close = useCallback(() => {
    if (closeCb) closeCb();
  }, [closeCb]);

  useKey("Escape", false, (e) => {
    e.preventDefault();
    e.stopPropagation();
    close();
  });

  const modalRoot = document.getElementById("modal-root");

  return ReactDOM.createPortal(
    <div
      className="right-sidebar-overlay"
      onClick={() => {
        close();
      }}
    >
      <div
        className="right-sidebar-panel"
        style={width ? { width } : undefined}
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
        }}
      >
        {children}
      </div>
    </div>,
    modalRoot
  );
}


